<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
    v-card
      v-card-title.px-4.h6.basic800--text {{ $t('select_source') }}
      v-divider.basic300
      v-card-text.px-4.pt-2
        template(v-if="store")
          div.h6.my-2 Yezza Store
          v-card.mb-4(outlined)
            v-list.pa-0
              v-list-item(:style="selectedForms.filter(f => f.id === store.id).length > 0 ? `background-color: ${$vuetify.theme.themes[$theme].successT08}` : ''" @click="selectItem(store)")
                v-col.px-0.text-left
                  div.d-flex.align-center
                    div.s1.basic800--text {{ store.name }}
                    template(v-if="selectedForms.filter(f => f.id === store.id).length > 0")
                      v-spacer
                      v-icon(color="success500" small) mdi-check-circle
                  div.c1.basic600--text.d-flex
                    div.pr-2 {{ $t('clicks') }}: {{ store.total_clicks }}
                    div.pl-2 {{ $t('sales') }}: {{ store.total_sales | displayPrice }}
          div.h6.my-2 WhatsApp Forms
        v-text-field(v-model="searchText" :placeholder="$t('search_form')" hide-details dense outlined height="40" background-color="basic200")
          template(v-slot:append)
            eva-icon(name="search-outline" :fill="$vuetify.theme.themes[$theme].basic600")
        div
          v-layout.my-6(v-if="isFetching")
            v-row.fill-height.ma-0(align='center' justify='center')
              v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
          .content(v-else)
            v-layout.my-6(v-if="forms.length == 0")
              v-row.fill-height.ma-0(align='center' justify='center')
                div.mx-auto
                  v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
                  p.caption {{ $t('forms_not_found') }}
            div.mt-4(v-else)
              v-card(outlined)
                v-list.pa-0
                  div(v-for='(form, index) in forms')
                    v-divider(v-if="index != 0")
                    v-list-item(:style="selectedForms.filter(f => f.id === form.id).length > 0 ? `background-color: ${$vuetify.theme.themes[$theme].successT08}` : ''" :key='form.id' @click="selectItem(form)")
                      v-col.px-0.text-left
                        div.d-flex.align-center
                          div.s1.basic800--text {{ form.name }}
                          template(v-if="selectedForms.filter(f => f.id === form.id).length > 0")
                            v-spacer
                            v-icon(color="success500" small) mdi-check-circle
                        div.c1.basic600--text.d-flex
                          div.pr-1 {{ $t('products') }}: {{ form.products.length }}
                          v-spacer
                          div.px-1 {{ $t('clicks') }}: {{ form.total_clicks }}
                          v-spacer
                          div.pl-1 {{ $t('sales') }}: {{ form.total_sales | displayPrice }}
              div.mt-4
                y-pagination.ma-4(v-model="page" :pageSize="fetchCount" :count="totalCount")

      v-card-actions.pa-4
        v-btn.mr-2(color='textColorAccent' block depressed height=32 @click="showModal = false" dark)
          .button-AA-small.basic100--text {{ $t('done') }}

</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
export default {
  name: 'AddSourceOrder',
  props: ['open', 'parentSelectedForms'],
  data: () => ({
    isFetching: true,
    fetchCount: 10,
    page: 1,
    searchText: '',
    forms: [],
    store: null,
    totalCount: 0,
    searchCountDown: null,
  }),
  computed: {
    ...mapState('user', ['member']),
    ...mapGetters({
      company: 'getCompany'
    }),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    selectedForms: {
      get() {
        return this.parentSelectedForms
      },
      set(newValue) {
        this.$emit('update:parentSelectedForms', newValue)
      }
    }
  },
  watch: {
    page (val) {
      if (!this.isFetching) {
        this.fetchForms(val)
      }
    },
    searchText () {
      if (this.searchCountDown) {
        clearTimeout(this.searchCountDown)
      }
      this.searchCountDown = setTimeout(() => {
        this.searchItem()
      }, 500)
    }
  },
  mounted () {

    this.fetchStore()
    this.fetchForms(1)
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchForms(page) {
      this.page = parseInt(page)
      this.isFetching = true
      let url = `/forms/?page=${page}&page_size=${this.fetchCount}&company=${this.company.id}&ordering=-total_sales&type_exclude=store&type_exclude=book_income&include_hidden=true`
      if (this.member.role === 'Agent') {
        url += `&members=${this.member.id}`
      }
      this.$axios.get(url)
        .then(response => {
          this.forms = response.data.results
          this.totalCount = response.data.count
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    fetchStore() {
      this.$axios.get(`/forms/?company=${this.company.id}&type=store&ordering=id`)
        .then(resp => {
          if (resp.data.results.length > 0) {
            this.store = resp.data.results[0]
            this.store.name = 'Yezza Store'
          }
        })
        .catch(() => {})        
    },
    searchItem () {
      let searchUrl = searchUrl = `/forms/?page=1&page_size=${this.fetchCount}&company=${this.company.id}&ordering=-total_sales&type_exclude=store&include_hidden=true`
      if (this.searchText) {
        searchUrl += `&search=${this.searchText}`
      }
      if (this.member.role === 'Agent') {
        searchUrl += `&members=${this.member.id}`
      }
      this.isFetching = true
      this.page = 1
      this.$axios.get(searchUrl)
        .then((response) => {
          this.isFetching = false
          this.forms = response.data.results
          this.totalCount = response.data.count
        }).catch(() => {})
    },
    selectItem (form) {
      if (this.selectedForms.filter(f => f.id === form.id).length > 0) {
        this.selectedForms = this.selectedForms.filter(f => f.id !== form.id)
      } else {
        this.selectedForms.push(form)
      }
      
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>
